import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { createStructuredSelector } from 'reselect';
import { injectIntl } from 'react-intl';
import { withRouter } from 'react-router-dom';
import { hot } from 'react-hot-loader';
import { compose } from 'ramda';

import { Card } from './card.component';
import { selectBookingCode } from '../../../../modules/booking/booking.selectors';
import { selectIsKioskMode } from '../../../../modules/kiosk/kiosk.selectors';
import { AuthActions } from '../../../../modules/auth';

const mapStateToProps = createStructuredSelector({
  bookingCode: selectBookingCode,
  isKioskMode: selectIsKioskMode,
});

export const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      signOut: AuthActions.signOut,
    },
    dispatch
  );

export default compose(
  hot(module),
  connect(
    mapStateToProps,
    mapDispatchToProps
  ),
  injectIntl,
  withRouter
)(Card);
